'use client'

import type {ReactNode} from 'react'

type Payload = {
   children: ReactNode
   delay?: number
   direction?: 'up' | 'down' | 'left' | 'right' | 'none'
}

/**
 * Scroll-triggered motion was removed; keeps the same wrapper API for pages.
 */
export const AnimateOnScroll = ({children}: Payload) => {
   return <>{children}</>
}
